var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    fill: "#4eb876",
    fillRule: "evenodd",
    d: "M2317.95,1085.26c0.02-.09.05-0.19,0.07-0.28,1.19-4.52,1.98-12.65,1.98-21.98s-0.79-17.45-1.98-21.97c-0.02-.1-0.05-0.19-0.07-0.29-0.04-.14-0.08-0.31-0.12-0.44v0.08a7.586,7.586,0,0,0-5.22-5.2h0.11c-0.18-.05-0.4-0.1-0.58-0.15-0.04-.01-0.07-0.02-0.1-0.03-4.51-1.19-12.67-1.99-22.03-1.99s-17.52.8-22.03,1.99c-0.04.01-.07,0.02-0.1,0.03-0.19.05-.41,0.1-0.58,0.15h0.1a7.609,7.609,0,0,0-5.23,5.22v-0.1c-0.05.17-.09,0.38-0.14,0.56-0.01.04-.02,0.08-0.03,0.13-1.19,4.51-2,12.65-2,22.01s0.81,17.51,2,22.02c0.01,0.04.02,0.08,0.03,0.13,0.05,0.18.09,0.39,0.14,0.55v-0.1a7.64,7.64,0,0,0,5.26,5.24h-0.13c4.35,1.29,12.88,2.17,22.71,2.17s18.36-.88,22.71-2.17h-0.13a7.622,7.622,0,0,0,5.24-5.22v0.08C2317.87,1085.57,2317.91,1085.4,2317.95,1085.26Z",
    transform: "translate(-2260 -1033)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M2279.33,1047a5.335,5.335,0,0,0-5.33,5.33v4.27a22.4,22.4,0,0,0,22.4,22.4h4.27a5.335,5.335,0,0,0,5.33-5.33v-2.95a3.187,3.187,0,0,0-1.77-2.86l-5.15-2.58a3.2,3.2,0,0,0-4.47,1.85l-0.64,1.91a1.509,1.509,0,0,1-1.73,1,11.846,11.846,0,0,1-9.28-9.28,1.509,1.509,0,0,1,1-1.73l2.37-.79a3.191,3.191,0,0,0,2.09-3.81l-1.25-5.01a3.19,3.19,0,0,0-3.1-2.42h-4.74Z",
    transform: "translate(-2260 -1033)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.dc735cf5.svg";
export { ForwardRef as ReactComponent };